module.exports = __webpack_public_path__ + "322e741a0b7729b461263627ff030a25.png";